// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__VBhKr {
  max-width: 721px;
}

.styles_heading__JyhMf {
  font-size: 36px;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  color: #313333;
  line-height: 50px;
}

.styles_subheading__pyxIt {
  color: #BABABA;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}

.styles_features__HOpM8 {
  background-color: #F3F5F7;
  box-shadow: 0 1px 1px rgba(47, 48, 53, 0.1), 0 2px 6px rgba(47, 48, 53, 0.1);
  border-radius: 16px;
}
.styles_featuresHeading__GzlZU {
  font-size: 24px;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  color: #313333;
}
.styles_featuresListItem__T\\+fdj {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.625rem;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #313333;
}
.styles_featuresCardInput__bwB\\+9 {
  background-color: #F3F5F7;
  padding: 18px 16px;
  border-radius: 12px;
  vertical-align: middle;
  outline: none;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #0084FF;
}
.styles_featuresCardInput__bwB\\+9:is(.styles_focus__BZmRu, .styles_active__8hY6H) {
  outline: none;
}
@media screen and (max-width: 1440px) {
  .styles_wrapper__VBhKr {
    max-width: 521px;
  }
}
@media screen and (max-width: 568px) {
  .styles_heading__JyhMf {
    font-size: 24px;
  }
  .styles_featuresHeading__GzlZU {
    font-size: 16px;
    line-height: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Subscription/styles.module.scss","webpack://./src/constants/fonts.scss","webpack://./src/constants/colors.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,kCCPQ;EDQR,gBAAA;EAEA,cEXM;EFYN,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gCCfM;EDgBN,gBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,4EAAA;EACA,mBAAA;AAFF;AAIE;EACE,eAAA;EACA,gCC1BI;ED2BJ,gBAAA;EAEA,cEhCI;AF6BR;AAOI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,gCCtCE;EDuCF,gBAAA;EACA,eAAA;EACA,cE5CE;AFuCR;AASE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,gCCnDI;EDoDJ,gBAAA;EACA,eAAA;EACA,cAAA;AAPJ;AASI;EACE,aAAA;AAPN;AAeA;EACE;IACE,gBAAA;EAbF;AACF;AAgBA;EACE;IACE,eAAA;EAdF;EAiBA;IACE,eAAA;IACA,iBAAA;EAfF;AACF","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.wrapper {\n  max-width: 721px;\n}\n\n.heading {\n  font-size: 36px;\n  font-family: $poppins;\n  font-weight: 700;\n\n  color: $black;\n  line-height: 50px;\n}\n\n.subheading {\n  color: #BABABA;\n  font-size: 16px;\n  font-family: $inter;\n  font-weight: 400;\n}\n\n.features {\n  background-color: #F3F5F7;\n  box-shadow: 0 1px 1px rgba(47, 48, 53, 0.1), 0 2px 6px rgba(47, 48, 53, 0.1);\n  border-radius: 16px;\n\n  &Heading {\n    font-size: 24px;\n    font-family: $inter;\n    font-weight: 700;\n\n    color: $black;\n  }\n\n  &List {\n    &Item {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.625rem;\n      font-family: $inter;\n      font-weight: 500;\n      font-size: 16px;\n      color: $black\n    }\n  }\n\n  &CardInput {\n    background-color: #F3F5F7;\n    padding: 18px 16px;\n    border-radius: 12px;\n    vertical-align: middle;\n    outline: none;\n    font-family: $inter;\n    font-weight: 500;\n    font-size: 14px;\n    color: #0084FF;\n\n    &:is(.focus, .active) {\n      outline: none;\n    }\n\n    &HalfSized {\n    }\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .wrapper {\n    max-width: 521px;\n  }\n}\n\n@media screen and (max-width: 568px) {\n  .heading {\n    font-size: 24px;\n  }\n\n  .featuresHeading {\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__VBhKr`,
	"heading": `styles_heading__JyhMf`,
	"subheading": `styles_subheading__pyxIt`,
	"features": `styles_features__HOpM8`,
	"featuresHeading": `styles_featuresHeading__GzlZU`,
	"featuresListItem": `styles_featuresListItem__T+fdj`,
	"featuresCardInput": `styles_featuresCardInput__bwB+9`,
	"focus": `styles_focus__BZmRu`,
	"active": `styles_active__8hY6H`
};
export default ___CSS_LOADER_EXPORT___;
